import { Image } from 'expo-image';
import { Href, useRouter, useSegments } from 'expo-router';
import { capitalize } from 'lodash';
import { Platform, StyleSheet, useWindowDimensions } from 'react-native';

import { urnBlack } from '@/assets/images';
import Text from '@/components/Text';
import nonHeaderRoutes from '@/constants/nonHeaderRoutes';
import { useAuth } from '@/contexts/authContext';
import { i18n } from '@/utils/i18n';

import { Button } from './ui/button';
import { SheetTrigger } from './ui/sheet';
import HeaderBar from './HeaderBar';

const Header = () => {
  const { width: screenWidth } = useWindowDimensions();
  const router = useRouter();
  const segments = useSegments() as string[];
  const { state, isBrowseOnlyUser } = useAuth();

  const validRoutes = ['home', 'trending', 'engage', 'impact'];
  const groupRegex = /^\(.*\)$/;
  const cleanedSegments = segments.filter((item) => !groupRegex.test(item));
  const cleanedPathname = '/' + cleanedSegments.join('/');

  const rightButtonGuard = validRoutes.includes(cleanedSegments.at(0) ?? '');

  if (nonHeaderRoutes.includes(cleanedPathname as Href)) return null;

  return (
    <nav className="flex items-center justify-between py-4 border-b bg-white relative z-10">
      <div className="container max-sm:px-10 flex flex-row justify-between max-w-6xl">
        <div className="items-center gap-4 flex h-9">
          <SheetTrigger className="text-gray-700 hover:text-gray-900 font-bold">
            <span className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
                <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
              </svg>
              <span className="sr-only">Menu</span>
            </span>
          </SheetTrigger>
          <Button variant={'ghost'} onClick={() => router.navigate('/home/npoTabs')}>
            <Image cachePolicy={'memory'} source={urnBlack} style={styles.logo} tintColor={'black'} />
            <Text fontWeight="900" style={styles.title}>
              {i18n.t('header.bs')}
            </Text>
          </Button>
        </div>
        {screenWidth >= 768 && Platform.OS === 'web' && rightButtonGuard && (
          <HeaderBar showSearch={false} containerStyle={styles.containerSearchBar} />
        )}
        {state.authReady && isBrowseOnlyUser && screenWidth < 768 && (
          <Button variant="default" onClick={() => router.navigate('/')}>
            {capitalize(i18n.t('mix.login'))}
          </Button>
        )}
      </div>
    </nav>
  );
};

export default Header;

const styles = StyleSheet.create({
  logo: {
    height: 20,
    width: 20,
    paddingVertical: 20
  },

  title: {
    flex: 1,
    fontSize: 14,
    color: 'black',
    textTransform: 'uppercase'
  },

  containerSearchBar: {
    flex: 1
  }
});
